import { Component, OnInit, OnChanges } from '@angular/core';
import { DefaultFilter } from 'ng2-smart-table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateService } from '../../services/date.service';

@Component({
  selector: 'app-date-filter',
  templateUrl: './date-filter.component.html',
  styleUrls: ['./date-filter.component.scss']
})
export class DateFilterComponent extends DefaultFilter implements OnInit, OnChanges {

  dateObj = {
    fromDate: null,
    toDate: null
  };
  formData = [
    {name: 'fromDate', label: 'From Date', type: 'date', required: true},
    {name: 'toDate', label: 'To Date', type: 'date', required: true},
  ];
  modalRef: any;
  placeHolder = 'DD/MM/YYYY';

  constructor(
    private modalService: NgbModal,
    private _date: DateService) {
    super();
  }

  ngOnInit(): void {
    

    // console.log(this);
  }

  ngOnChanges(changes: any) {
    const vm = this;
    if (vm.dateObj.fromDate && vm.dateObj.toDate) {
      console.log(vm.dateObj);

      const fromObj = {
        day: (vm.dateObj.fromDate['day'].toString().length > 1) ? vm.dateObj.fromDate['day'] : ('0' + vm.dateObj.fromDate['day']),
        month: (vm.dateObj.fromDate['month'].toString().length > 1) ? vm.dateObj.fromDate['month'] : '0' + vm.dateObj.fromDate['month'],
        year: vm.dateObj.fromDate['year'].toString()
      };

      const toObj = {
        day: (vm.dateObj.toDate['day'].toString().length > 1) ? vm.dateObj.toDate['day'] : ('0' + vm.dateObj.toDate['day']),
        month: (vm.dateObj.toDate['month'].toString().length > 1) ? vm.dateObj.toDate['month'] : '0' + vm.dateObj.toDate['month'],
        year: vm.dateObj.toDate['year'].toString()
      };

      this.query = fromObj['month'] + '/' + fromObj['day'] + '/' + fromObj['year'] + '-' + toObj['month'] + '/' + toObj['day'] + '/' + toObj['year'];
      vm.placeHolder = vm.dateObj.fromDate['day'] + '/' + vm.dateObj.fromDate['month'] + '/' + vm.dateObj.fromDate['year'] + '-' + vm.dateObj.toDate['day'] + '/' + vm.dateObj.toDate['month'] + '/' + vm.dateObj.toDate['year'];

    } else {
      this.query = null;
      vm.placeHolder = 'DD/MM/YYYY';
    }
    this.setFilter();
    vm.onClose();
  }

  openPoupUP(content) {
    const vm = this;
    vm.modalRef = vm.modalService.open(content, { backdrop: 'static', size: 'lg' });
  }

  onClear() {
    const vm = this;
    vm.dateObj.fromDate = null;
    vm.dateObj.toDate = null;
  }

  onClose() {
    const vm = this;
    if (vm.modalRef) {
      vm.modalRef.close();
    }
  }

}
